import { HTMLAttributes } from 'react';

import { cn } from '@components/primitives';

import css from './Dialog.module.css';

export function DialogFooter({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(css.footer, className)} {...props}>
      {children}
    </div>
  );
}
